import { connect } from 'react-redux'
import { IPaymentMethods, IStoreState } from '../../types/index'
import ServiceViewPricingBreakdown from '../../components/services/view/ServiceViewPricingBreakdown'
import { fetchServicePricingItem } from '../../state/actions/services/servicePricing'
import { getServicePricing } from '../../state/reducers/services/servicePricing'
import { IServicePricingModel } from '../../types/service-pricing'
import { fetchPaymentMethods, fetchServicePricingDiscount } from 'src/state/actions/services'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  const serviceId = ownProps.serviceId
  const orgId = state.organizations.currentOrgId
  const { servicePricingDiscount } = state.service
  let pricing: IServicePricingModel | undefined
  if (serviceId && orgId) {
    pricing = getServicePricing(state, serviceId, orgId)
  }
  const paymentMethods: IPaymentMethods[] = state.service.paymentMethods
  return {
    serviceId,
    orgId,
    pricing,
    paymentMethods,
    servicePricingDiscount
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    onComponentMount: (serviceId: string, orgId: string) => {
      dispatch(fetchServicePricingItem(serviceId, orgId))
      dispatch(fetchServicePricingDiscount(serviceId))
      dispatch(fetchPaymentMethods(serviceId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewPricingBreakdown)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewPricingBreakdown.ts